export default () => {
  document.querySelectorAll(".js-rich-text").forEach((rte) => {
    rte.querySelectorAll(".js-rte-scroll-into-view").forEach((el) => {
      // check for when the embed enters from the bottom
      const enterPageObserver = new IntersectionObserver(
        (entries, observer) => {
          // using setTimeout to ignore the affect when jump links are clicked
          entries.forEach((entry, i) => {
            if (entry.isIntersecting) {
              entry.target.classList.add("scrolled-into-view");
            } else {
              entry.target.classList.remove("scrolled-into-view");
            }
          });
        },
        {
          root: null,
          rootMargin: "0px 0px -50%",
          threshold: 0,
        },
      );

      enterPageObserver.observe(el);

      const markCoveredItems = () => {
        rte
          .querySelectorAll(".is-covered")
          .forEach((el) => el.classList.remove("is-covered"));

        const tops = rte.querySelectorAll(".at-top");
        // mark all but the last one "length - 1"
        for (let i = 0; i < tops.length - 1; i++) {
          tops[i].classList.add("is-covered");
        }
      };

      // check for when the embed reaches the top of the page
      const pageTopObserver = new IntersectionObserver(
        (entries, observer) => {
          entries.forEach((entry, i) => {
            if (entry.isIntersecting) {
              entry.target.classList.add("at-top");
              markCoveredItems();
            } else {
              entry.target.classList.remove("at-top");
              markCoveredItems();
            }
          });
        },
        {
          root: null,
          rootMargin: "0px 0px -80%",
          threshold: 0,
        },
      );

      pageTopObserver.observe(el);
    });
  });
};
